





















































































import {
  computed,
  defineComponent, reactive, Ref, ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter } from '@ideavivat/vivat-2';

import {
  getSubJobs, massUpdateSubJob, updateSubJob, duplicateSubJob,
} from '@/api/index';
import useSubJob from '@/use/useSubJob';
import pending from '@/table/Job/SubJob/assembly';
import receive from '@/table/Job/SubJob/assembly_receive';
import progress from '@/table/Job/SubJob/assembly_progress';
import done from '@/table/Job/SubJob/assembly_done';
import failed from '@/table/Job/SubJob/assembly_failed';
import useAuth from '@/use/useAuth';
import CommonModalWithAmountStatusUpdate from '@/components/Job/CommonModalWithAmountStatusUpdate.vue';

const { statusToAssemblyAmountColumn, statusToQCAmountColumn } = useSubJob();
const presetFilters = [
  {
    name: '0',
    display: 'ยังไม่ถูกเบิก',
    table: pending,
    amountColumn: 'store_amount',
    currentStatus: 'STORE',
    filterStoreAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
  {
    name: '1',
    display: 'เบิกชิ้นส่วนแล้ว',
    table: receive,
    amountColumn: statusToAssemblyAmountColumn('RECEIVE'),
    currentStatus: 'RECEIVE',
    filterAssemblyReceiveAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
  {
    name: '2',
    display: 'ระหว่างประกอบ',
    table: progress,
    amountColumn: statusToAssemblyAmountColumn('IN_PROGRESS'),
    currentStatus: 'INPROGRESS',
    filterAssemblyProgressAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
  {
    name: '3',
    display: 'ประกอบเสร็จสิ้น',
    table: done,
    amountColumn: statusToAssemblyAmountColumn('DONE'),
    currentStatus: 'DONE',
    filterAssemblyDoneAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
  {
    name: '4',
    display: 'ประกอบล้มเหลว',
    table: failed,
    amountColumn: statusToAssemblyAmountColumn('FAILED'),
    currentStatus: 'FAILED',
    filterAssemblyFailedAmount: 0,
    filterExceptStatus: 'CANCELLED',
  },
];

const Assembly = defineComponent({
  components: {
    CommonModalWithAmountStatusUpdate,
  },
  setup(props, { emit, root }) {
    const { route } = useRouter();
    const { hasPermission: checkPermissionHandler } = useAuth();
    const refetchQuery = ref(false);
    const pendingSearch = _.debounce(() => { refetchQuery.value = true; }, 250);
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }

    const selectedFilterIndex = ref('0');
    const filter = reactive({
      searchString: '',
      status: 'DONE',
      filterOutsource: undefined,
      filterBomId: route.value.params.id,
    });
    const computedFilter = computed(() => {
      const vars = {
        ...presetFilters[selectedFilterIndex.value as any],
        searchString: undefined,
        status: 'DONE',
        filterOutsource: undefined,
        filterBomId: route.value.params.id,
      };

      if (filter.searchString !== '') {
        vars.searchString = filter.searchString as any;
      }
      return vars;
    });

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    const selectedItem: Ref<any[]> = ref([]);
    const totalItems = ref(0);

    function selectItem(id: number | string, item: any) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) {
        selectedItemId.value.splice(hitIndex, 1);
        selectedItem.value.splice(hitIndex, 1);
      } else {
        selectedItemId.value.push(parseInt(id as string, 10));
        selectedItem.value.push(item);
      }
    }
    // Use to mass update sub job status
    const updateAmountWithStatusModal = ref(null);
    async function massUpdateStatus(payload: any) {
      (updateAmountWithStatusModal.value as any).compose({
        items: selectedItem.value,
        ...payload,
        text: payload.assemblyStatus,
        old_column: presetFilters[selectedFilterIndex.value as any].amountColumn,
      });
    }

    const tableData = ref([]);
    function handlerFetchData(queryData: any) {
      const { data, from, to } = queryData;
      totalItems.value = (to - from) + 1;
      tableData.value = data;
    }
    function handleSelectAllItem($event: any[]) {
      if (selectedItemId.value.length === tableData.value.length) {
        selectedItemId.value = [];
        selectedItem.value = [];
      } else {
        selectedItemId.value = $event;
        selectedItem.value = tableData.value;
      }
    }
    const selectedAll = computed(() => selectedItemId.value.length === totalItems.value);

    function tabChangeHandler(tabName: string) {
      selectedFilterIndex.value = tabName;
      selectedItemId.value = [];
      selectedItem.value = [];
      pendingSearch();
    }

    async function updateSingleSubJobStatus(item: any, payload: any) {
      (updateAmountWithStatusModal.value as any).compose({
        items: [item],
        ...payload,
        currentStatus: presetFilters[selectedFilterIndex.value as any].currentStatus,
        text: payload.assemblyStatus,
        old_column: presetFilters[selectedFilterIndex.value as any].amountColumn,
      });
    }
    return {
      hasPermission,

      getSubJobs,
      refetchQuery,
      presetFilters,
      filter,
      computedFilter,
      tabChangeHandler,
      selectedFilterIndex,

      handlerFetchData,
      handleSelectAllItem,
      selectedAll,

      duplicateSubJob,

      selectedItemId,
      selectedItem,
      totalItems,
      selectItem,

      updateAmountWithStatusModal,
      massUpdateStatus,
      updateSingleSubJobStatus,
    };
  },
});

export default Assembly;
